
<div
  :id="vnodeId"
  ref="Container"
  data-identity="CContainer"
  :data-vnode-id="vnodeId"
  :class="containerRootClasses"
  @click="onEditAction"
  @mouseenter="mouseOverAction"
  @mouseleave="mouseLeaveAction"
  @contextmenu.prevent.stop="showContextMenu"
  @dblclick="resize"
>
  <div :class="ContainerBgImage" />
  <div :class="ContainerBgColor" />

  <div
    v-if="!fbNode.children && !backgroundImgExist"
    class="d-flex w-100 h-100"
  >
    <img
      src="/img/box-container-placeholder-.svg"
      class="img-fluid"
      style="height: 100%; width: 100%"
      alt="empty container"
    />
  </div>

  <div v-if="fbNode.children" ref="containerStacks" :class="containerInnerClasses">
    <template v-for="node in fbNode.children || []">
      <c-container-item
        v-bind="node.data.props"
        :key="node.data.props.vnodeId"
        :fb-node="node"
        class="c-container-item"
        @removeElement="removeNode"
        @duplicateElement="duplicateNode"
        @forceRemoveElement="forceRemoveNode"
      ></c-container-item>
    </template>
  </div>
</div>
